import dayjs, { Dayjs } from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat.js";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isoWeek from "dayjs/plugin/isoWeek";
import minMax from "dayjs/plugin/minMax";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekday from "dayjs/plugin/weekday";

dayjs.extend(weekOfYear);
dayjs.extend(isoWeek);
dayjs.extend(advancedFormat);
dayjs.extend(minMax);
dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.extend(isBetween);
dayjs.extend(weekday);
dayjs.extend(duration);
dayjs.extend(isSameOrAfter);
// customParseFormat plugin is necessary for date validation to work correctly
// https://stackoverflow.com/questions/58216504/dayjs-isvalid-behaves-differently-to-moment
dayjs.extend(customParseFormat);

dayjs.utc();

export const dateFormat = "YYYY-MM-DD";

export const today = dayjs().startOf("day");
export const yesterday = today.subtract(1, "day");
export const startOfWeekDay = today.startOf("week");
export const weekAgo = today.subtract(1, "week");
export const startOfMonthDay = today.startOf("month");
export const monthAgo = today.subtract(1, "month");
export const startOfYearDay = today.startOf("year");
export const isTodayLastDayOfMonth = today.date() === today.endOf("month").date();

export { dayjs, Dayjs };
